"use strict";
exports.__esModule = true;
exports.validatePermissions = exports.validateAuthorizationConfig = exports.validateConfigType = exports.validateConfigProperties = exports.validateOptionalFieldType = exports.validateFieldType = exports.validateFieldKey = exports.validateNamespace = exports.validateDisplayName = exports.validateDisplayField = exports.validateCollectionId = void 0;
var validate_1 = require("./utils/validate");
var fieldConfigSchemas_1 = require("./fieldConfigSchemas");
var authorizationConfigSchema_1 = require("./authorizationConfigSchema");
var permissionsSchema_1 = require("./permissionsSchema");
var validateCollectionId = validate_1.validate('collectionId', validate_1.string);
exports.validateCollectionId = validateCollectionId;
var validateDisplayField = validate_1.validate('displayField', validate_1.string);
exports.validateDisplayField = validateDisplayField;
var validateDisplayName = validate_1.validate('displayName', validate_1.string);
exports.validateDisplayName = validateDisplayName;
var validateNamespace = validate_1.validate('namespace', validate_1.string);
exports.validateNamespace = validateNamespace;
var validateFieldKey = validate_1.validate('fieldKey', validate_1.string);
exports.validateFieldKey = validateFieldKey;
var validateFieldType = validate_1.validate('config.type', validate_1.string);
exports.validateFieldType = validateFieldType;
var validateOptionalFieldType = validate_1.validate('config.type', validate_1.optional(validate_1.string));
exports.validateOptionalFieldType = validateOptionalFieldType;
var validateConfigProperties = function (config) {
    return validate_1.validate('config', validate_1.objectProperties(fieldConfigSchemas_1["default"][config.type] ||
        fieldConfigSchemas_1["default"]["default"]))(config);
};
exports.validateConfigProperties = validateConfigProperties;
var validateConfigType = validate_1.validate('config', validate_1.object);
exports.validateConfigType = validateConfigType;
var validateAuthorizationConfig = validate_1.validate('authorizationConfig', validate_1.objectProperties(authorizationConfigSchema_1.authorizationConfigSchema));
exports.validateAuthorizationConfig = validateAuthorizationConfig;
var validatePermissions = validate_1.validate('permissions', validate_1.objectProperties(permissionsSchema_1.permissionsSchema));
exports.validatePermissions = validatePermissions;
//# sourceMappingURL=validators.js.map